import { FunctionComponent } from 'react';
import { lazyWithReload } from './lazyWithReload';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Suspense } from './Suspense';
import { paths } from './paths';
import { EFeatureName, Platform } from 'src/graphql/generated';
import { useTranslation } from 'src/hooks/useTranslation';

import MarketplaceSelector from 'src/components/MarketplaceSelector/MarketplaceSelector';
import { MarketplaceSelectorBloc } from 'src/components/MarketplaceSelector/MarketplaceSelectorBloc';

import { marketplacesRoutes } from './ConnectMarketplacesRoutes';
import { GetUserResult } from 'src/services/user/UserService';

const FeedLoading = lazyWithReload(
    () => import('../screens/Onboarding/FeedLoading' /* webpackChunkName: "FeedLoading" */),
);
const FeedError = lazyWithReload(() => import('../screens/Onboarding/FeedError' /* webpackChunkName: "FeedError" */));
const DataSourceSelection = lazyWithReload(
    () =>
        import(
            '../screens/Onboarding/dataSource/DataSourceSelectionOnboarding' /* webpackChunkName: "DataSourceSelection" */
        ),
);
const OnboardingWizardShoptet = lazyWithReload(
    () =>
        import(
            '../screens/Onboarding/dataSource/shoptet/OnboardingWizardShoptet' /* webpackChunkName: "OnboardingWizardShoptet" */
        ),
);
const OnboardingWizardXML = lazyWithReload(
    () =>
        import(
            '../screens/Onboarding/dataSource/xml/OnboardingWizardXML' /* webpackChunkName: "OnboardingWizardXML" */
        ),
);
const OnboardingWizardCSV = lazyWithReload(
    () =>
        import(
            '../screens/Onboarding/dataSource/csv/OnboardingWizardCSV' /* webpackChunkName: "OnboardingWizardCSV" */
        ),
);

export const OnboardingRoutes: FunctionComponent<{ user: GetUserResult }> = (userSettings) => {
    const { t } = useTranslation();

    return (
        // <Route key={'onboarding'} path={'onboarding'} element={<ProtectedRoute />} >
        <Routes>
            <Route path="feed-loading" element={<Suspense element={FeedLoading} />} />
            <Route path="feed-error" element={<Suspense element={FeedError} />} />

            <Route path="connect-data-source">
                <Route path="shoptet" element={<Suspense element={OnboardingWizardShoptet} />} />
                <Route path="xml" element={<Suspense element={OnboardingWizardXML} />} />
                <Route path="csv" element={<Suspense element={OnboardingWizardCSV} />} />
                <Route index element={<Suspense element={DataSourceSelection} />} />
            </Route>

            <Route path="connect-marketplaces">
                {marketplacesRoutes(true, t)}
                <Route
                    index
                    element={
                        <MarketplaceSelector
                            bloc={
                                new MarketplaceSelectorBloc(
                                    [Platform.shoptet, Platform.real],
                                    t,
                                    userSettings.user?.features?.pass?.includes(EFeatureName.partner_marketplaces) ??
                                        false,
                                )
                            }
                        />
                    }
                />
                <Route path="*" element={<Navigate to={paths.onboarding.connectMarketplaces} replace />} />
            </Route>

            <Route element={<Navigate to={paths.onboarding.connectDataSource} replace />} />
        </Routes>
    );
};
